import React, { useEffect, useRef, useState } from "react";

export const AutocompleteCustom = ({ onPlaceSelect, value, onChange }) => {
  const inputRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google && window.google.maps && window.google.maps.places) {
        setLoaded(true);
        clearInterval(interval);
      }
    }, 100); // check every 100ms

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!loaded || !inputRef.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ["(cities)"],
      componentRestrictions: { country: "us" },
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      onPlaceSelect(place);
    });
  }, [loaded]);

  return (
    <input
      ref={inputRef}
      type="text"
      className="exact-input"
      placeholder="Search for a place"
      value={value}
      onChange={onChange}
    />
  );
};
